angular.module('FlexyBeautyApp.services')
    .factory('Brand', [
        function() {
            return {
                label: "Kiute Pro",
                newLabel: "Booksy",
                labelDownload: "kiutepro",
                appYear: "2020",
                billing: {
                    name: "Kiute Sas",
                    address: "100 rue La Fayette",
                    zipcode: "75010",
                    city: "Paris",
                    country: "France",
                    siren: "799889704",
                    siret: "79988970400018",
                    rcs: "Paris B 799 889 704",
                    vat: "FR 92 799889704"
                },
                contact: {
                    phone: "01 79 72 55 05",
                    supportEmail: "support@kiute.com"
                },
                url: {
                    website: "https://pro.kiute.com/fr",
                    app: "https://app.kiute.com",
                    sponsorship: "https://kiute.typeform.com/to/iOgFHex2",
                    intercom: "https://intercom.help/KiuteProSupport",
                    hubspot: "https://app.hubspot.com/meetings/flexybeauty-cs",
                    unsubscribe: "https://start.flexy.co/desabonnement-flexy",
                    subscribeSSO: "https://app.hubspot.com/meetings/kimberley-congre/15-minutes-pour-decouvrir-loffre-kiute-speciale-clients-flexy",
                    groupUrl: "/kiute-group/",
                    adminUrl: "/fxbAdmin/",
                    offerPrices: "https://pro.kiute.com/fr/tarifs",
                    landingPage: "https://lp.kiute.com/saas-to-marketplace",
                    booksyUrl: "https://hook.eu1.make.com/hh8d1nq64fl7h6mh7d1aobxdhlkf7b6l",
                    discoverBooksyUrl: "https://storage.googleapis.com/flexy-assets/migration/booksy-brand.html",
                },
                images: {
                    logo: "/img/logo-booksy.svg",
                    logoWhite: "/img/logo-booksy-white.svg",
                    logoSingleLetter: "/img/logo-booksy.png",
                    logoBooksyHeader: "/img/logo-booksy-header.png",
                },
                marketplace: {
                    domain: "marketplace",
                    label: "Kiute",
                    url: {
                        website: "www.kiute.fr",
                        shortWebsite: "kiute.fr",
                        proSite: "https://marketplace.kiute.fr/login"
                    },
                    images: {
                        greyLogoUrl: "img/kiute-icon-grey.svg",
                        planningLogoUrl: "img/kiute_favicon_RVB.svg"
                    },
                    phoneNumber: "01.84.80.04.40"
                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./js/constants/BrandConstants.js